import { pickBy } from 'lodash-es';
import { isNotBlank } from '@is24at/react-utils';
import {
  reloadRouteByPushingUrl,
  setSearchQuery,
} from '../../modules/resultList';

/**
 * Navigates to result list.
 */
export const onSubmit = (values: any, history: any) => (dispatch: any) => {
  const valuesWithoutEmptyStrings = pickBy(values, (value) =>
    isNotBlank(value),
  );
  reloadRouteByPushingUrl(valuesWithoutEmptyStrings, history);
  dispatch(setSearchQuery(valuesWithoutEmptyStrings));
};
